module.exports = __webpack_public_path__ + "static/vishwajeet-5b4c827d5536bb605eb2809f9595b72e.png";